import React from 'react';
import './Tooltip.css';

function Tooltip({ text, children }) {
  if (!text) return children;

  return (
    <span className="tooltip-wrapper">
      {children}
      <span className="tooltip-text" role="tooltip">
        {text}
      </span>
    </span>
  );
}

export default Tooltip;
